export const BUSINESS_TZ = "America/Merida";

export const detectTZ = () => {
  try { return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC"; }
  catch { return "UTC"; }
};

export const COMMON_TZS = [
  "America/New_York", "America/Chicago", "America/Denver", "America/Phoenix",
  "America/Los_Angeles", "America/Anchorage", "Pacific/Honolulu",
  "America/Merida", "America/Mexico_City", "America/Toronto", "Europe/London", "Europe/Madrid",
];

function tzOffsetMs(tz, date) {
  const dtf = new Intl.DateTimeFormat("en-US", {
    timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: false,
  });
  const p = Object.fromEntries(dtf.formatToParts(date).map((x) => [x.type, x.value]));
  const asIfUTC = Date.UTC(+p.year, +p.month - 1, +p.day, +(p.hour % 24 || p.hour), +p.minute, +p.second);
  return asIfUTC - date.getTime();
}

// Convert a Mérida-local "YYYY-MM-DDTHH:MM" slot string to a real Date (exact instant).
export function meridaToDate(slotStr) {
  if (!slotStr) return null;
  const [dpart, tpart = "00:00"] = slotStr.split("T");
  const [y, mo, d] = dpart.split("-").map(Number);
  const [h, mi] = tpart.split(":").map(Number);
  const guess = Date.UTC(y, mo - 1, d, h, mi);
  const off = tzOffsetMs(BUSINESS_TZ, new Date(guess));
  return new Date(guess - off);
}

export const slotDate = (slot) => (slot?.utc ? new Date(slot.utc) : meridaToDate(slot?.datetime || slot));

export const fmtTime = (date, tz) =>
  date ? new Intl.DateTimeFormat("en-US", { timeZone: tz, hour: "numeric", minute: "2-digit" }).format(date) : "";

export const fmtDateTime = (date, tz) =>
  date ? new Intl.DateTimeFormat("en-US", { timeZone: tz, weekday: "short", month: "short", day: "numeric", hour: "numeric", minute: "2-digit" }).format(date) : "";

export function tzAbbrev(tz, date = new Date()) {
  try {
    const parts = new Intl.DateTimeFormat("en-US", { timeZone: tz, timeZoneName: "short" }).formatToParts(date);
    return parts.find((p) => p.type === "timeZoneName")?.value || tz;
  } catch { return tz; }
}

export function localHour(date, tz) {
  return +new Intl.DateTimeFormat("en-US", { timeZone: tz, hour: "numeric", hour12: false }).format(date);
}
